// extracted by mini-css-extract-plugin
module.exports = {"container":"_KezJGUvF","logo":"_mGVXjb9k","bannerImage":"_MV44JH7_","advertising":"_RGKJAFrA","link":"_TInVTf7T"};